import React, { useState } from "react";
import { UseFormRegister, UseFormWatch } from "react-hook-form";
import { RentReceiptForm } from ".";
import { REGEX } from "../../../../constants/regex";
import { getFYEndDate } from "../../../../helpers";

const RentDetails = ({
  register,
  watch,
}: {
  register: UseFormRegister<RentReceiptForm>;
  watch: UseFormWatch<RentReceiptForm>;
}) => {
  const formValues = watch();
  return (
    <div className="mt-[40px] px-[24px]">
      <div className="flex justify-between gap-4">
        <DateInput
          label="Start Date"
          value={formValues.startDate}
          register={{
            ...register("startDate", { required: "Start date is required." }),
          }}
        />
        <DateInput
          maxDate={getFYEndDate(formValues.startDate)}
          minDate={formValues.startDate}
          value={formValues.endDate}
          label="End Date"
          register={{
            ...register("endDate", { required: "End date is required." }),
          }}
        />
      </div>
      <div className="mt-4">
        <InputField
          label="Home Owner’s Name"
          value={formValues.ownerName}
          register={{
            ...register("ownerName", { required: "Owner's name is required." }),
          }}
        />
      </div>
      <div className="mt-4">
        <InputField
          label="Home Owner’s PAN Number (Optional)"
          value={formValues.ownerPan}
          register={{
            ...register("ownerPan", {
              pattern: {
                value: REGEX.PAN_NUMBER,
                message: "Please enter a valid PAN.",
              },
            }),
          }}
        />
      </div>
      <div className="mt-4">
        <InputField
          label="Rented House Address"
          value={formValues.address}
          register={{
            ...register("address", {
              required: "Address is required.",
              minLength: 5,
            }),
          }}
        />
      </div>
    </div>
  );
};

interface InputFieldProps {
  label: string;
  value?: string;
  placeholder?: string;
  register?: any;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}
interface DateFieldProps {
  label: string;
  value?: string;
  placeholder?: string;
  register?: any;
  maxDate?: string;
  minDate?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const InputField: React.FC<InputFieldProps> = ({
  label,
  placeholder,
  value,
  register,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className="relative w-full">
      <input
        type="text"
        {...register}
        placeholder={placeholder}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(value !== "")} // Keeps label up if there's text
        className={`w-full px-4 pt-6 pb-2 text-lg border border-[#d7d7d7] rounded-[10px] bg-[#fff] 
              focus:outline-none focus:ring-2 focus:ring-[#e6d58d] focus:border-transparent
              peer`}
      />
      <label
        className={`absolute left-4 text-gray-400 transition-all 
              ${isFocused || value ? "top-2 text-[11px]" : "top-4 text-[18px]"}`}
      >
        {label}
      </label>
    </div>
  );
};

const DateInput = ({
  label,
  placeholder,
  register,
  maxDate,
  minDate,
}: DateFieldProps) => {
  return (
    <div className="relative w-full">
      <input
        {...(maxDate && { max: maxDate })}
        {...(minDate && { min: minDate })}
        type="date"
        {...register}
        placeholder={placeholder}
        className={`w-full px-4 pt-6 pb-2 text-lg border border-[#d7d7d7] rounded-[10px] bg-[#fff] 
              focus:outline-none focus:ring-2 focus:ring-[#e6d58d] focus:border-transparent
              peer`}
      />
      <label
        className={`absolute left-4 text-gray-400 transition-all 
              top-2 text-[11px]`}
      >
        {label}
      </label>
    </div>
  );
};

export default RentDetails;
